module.exports = __webpack_public_path__ + "static/media/file_example_MP4_480_1_5MG943111296.2e22d47d.mp4";